/**
 * Reads the Vite public environment. Nothing here may hold a secret: every
 * VITE_* value is inlined into the JavaScript bundle and is world readable.
 */
const raw = import.meta.env;
const configuredApiBaseUrl = raw.VITE_API_BASE_URL ?? '/api/v1';
const localApiPattern = /^https?:\/\/(?:127\.0\.0\.1|localhost)(?::|\/|$)/i;

// A local API URL is convenient in web/.env during development, but shipping it
// in a production bundle makes every visitor call their own computer. Fall back
// to the same-origin API in that case while preserving real production URLs.
const apiBaseUrl = raw.PROD && localApiPattern.test(configuredApiBaseUrl)
  ? '/api/v1'
  : configuredApiBaseUrl;

export const env = {
  apiBaseUrl: apiBaseUrl.replace(/\/+$/, ''),
  supabaseUrl: raw.VITE_SUPABASE_URL ?? '',
  supabaseAnonKey: raw.VITE_SUPABASE_ANON_KEY ?? '',
  turnstileSiteKey: raw.VITE_TURNSTILE_SITE_KEY ?? '',
};

/** Auth screens are disabled until Supabase is configured, instead of crashing. */
export const isAuthConfigured = Boolean(env.supabaseUrl && env.supabaseAnonKey);
